import { render, staticRenderFns } from "./UserEkspedisiUpdate.vue?vue&type=template&id=4706b58e&scoped=true&"
import script from "./UserEkspedisiUpdate.vue?vue&type=script&lang=js&"
export * from "./UserEkspedisiUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UserEkspedisiUpdate.vue?vue&type=style&index=0&id=4706b58e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706b58e",
  null
  
)

export default component.exports